<template>
    <footer :class="$style.footer">
        <Typography
            is="ul"
            type="paragraph"
            size="xs"
            :class="$style.links"
        >
            <li
                v-for="item in links"
                :key="item.title"
            >
                <Link
                    :to="item.to"
                    :externalTo="item.externalTo"
                    :target="item.target"
                    color="white-60"
                    :class="$style.link"
                    @click="item.onClick"
                >
                    {{ item.title }}
                </Link>
            </li>
        </Typography>
    </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import Link from '@/components_new/Link.vue'
import Typography from '@/components_new/Typography.vue'
import { useTr } from '@/composables/use-tr'
import { ROUTE_NAMES } from '@/router/constants'
import { type NavLink } from '@/router/navigation-constants'

type FooterLink = NavLink & {
    onClick?: (event: MouseEvent) => void
}

const tr = useTr()

const links = computed<FooterLink[]>(() => {
    const navLinks = [
        {
            title: tr('navigation.about_us'),
            to: { name: ROUTE_NAMES.WHITE_LABEL_ABOUT_US },
            target: '_blank',
        },
        {
            title: tr('navigation.privacy_policy'),
            to: { name: ROUTE_NAMES.WHITE_LABEL_CONFIDENTIAL },
        },
        {
            title: tr('navigation.contact_us'),
            to: { name: ROUTE_NAMES.WHITE_LABEL_CONTACTS },
        },
        {
            title: tr('navigation.terms_of_use'),
            to: { name: ROUTE_NAMES.WHITE_LABEL_TERMS_OF_USE },
        },
    ]

    return [
        ...navLinks,
        {
            title: 'Cookie preferences',
            externalTo: 'about:blank',
            onClick: (event: MouseEvent) => {
                event.preventDefault()
                window.googlefc?.showRevocationMessage?.()
            },
        },
    ] as FooterLink[]
})
</script>

<style module>
.footer {
    margin-top: 32px;
    padding-bottom: 24px;
}

.links {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 18px;
    list-style: none;
    margin: 0;
    padding: 0;
}

.link {
    white-space: nowrap;
}
</style>
